<template>
    <div>

        <v-app-bar :height="appBarHeight" app clipped-left color="primary darken-2">

        </v-app-bar>

        <div id="main-map" style="height:800px"></div>

        <SideBar v-if="ready" :mainMap="mainMap"></SideBar>

    </div>
</template>

<script>

import MainMap from '../classes/MainMap'
import SideBar from './SideBar.vue'
import TileServerClient from '../classes/TileServerClient'

export default {
  
    components: 
    {
        SideBar
    },

    data: () => ({
        ready : false,
        appBarHeight: 1,
    }),

    provide: () => ({
        tileServerClient : new TileServerClient(process.env.VUE_APP_TILESERVER_URL),
    }),

    mounted() {

        let map = document.getElementById('main-map');

        map.style.height = document.body.clientHeight - this.appBarHeight + 'px';

        this.mainMap = new MainMap('main-map', this.$vuetify.theme.currentTheme.secondary, this.$vuetify.theme.currentTheme.error);

        this.ready = true;
     
    },

};
</script>
